import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Routes from "./routes";
import ThemeProvider from "./theme";
import { StyledChart } from "./components/chart";
import ScrollToTop from "./components/scroll-to-top";
import { auth } from "./firebase";
import { useDispatch, useSelector } from "react-redux";
import { loginUser, setLoading } from "./redux/authSlice";

export default function App() {
	const dispatch = useDispatch();
	const user = useSelector((state) => state.data.auth.user);
	const role = useSelector((state) => state.data.auth.role); // Access the role

	useEffect(() => {
		const unsubscribe = auth.onAuthStateChanged(async (authUser) => {
			if (authUser) {
				const idToken = await authUser.getIdToken();
				dispatch(
					loginUser({
						uid: authUser.uid,
						email: authUser.email,
						displayName: authUser.displayName,
						idToken: idToken,
					})
				);
			} else {
				localStorage.removeItem("idToken"); // optional cleanup
			}
			dispatch(setLoading(false));
		});
		return () => unsubscribe();
	}, []);

	return (
		<HelmetProvider>
			<BrowserRouter>
				<ThemeProvider>
					<ScrollToTop />
					<StyledChart />
					<Routes />
				</ThemeProvider>
			</BrowserRouter>
		</HelmetProvider>
	);
}

